import { post, get } from "./axios"; // put, deleteFun
export function login(data) {
  return post({
    url: `/common/login/index`,
    data: {
      params: JSON.stringify({ ...data }),
    },
  });
}
export function getInfo(token) {
  return get({ url: `/common/login/getUserInfo?token=${token}`, token });
}
export function logout() {
  return post({ url: "/common/login/logout" });
}
export function editManagerInfo() {
  return get({ url: "/common/login/editManagerInfo" });
}
export function updateManagerInfo(data) {
  return post({ url: "/common/login/updateManagerInfo", data });
}

// 菜单列表
export function getRoutes(params) {
  return get({
    url: "/common/RolePermission/treeData",
    data: {
      ...params,
    },
  });
}
// 角色列表
export function getRoles(params) {
  return get({
    url: "/common/RolePermission/getRoleList",
    data: { params: JSON.stringify({ ...params }) },
  });
}
// 新建角色
export function addRole(params) {
  return post({
    url: "/common/RolePermission/addRole",
    data: { params: JSON.stringify({ ...params }) },
  });
}
// 新建角色
export function updateRole(params) {
  return post({
    url: "/common/RolePermission/updateRole",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 获取角色信息
export function getRoleInfo(id) {
  return get({
    url: "/common/RolePermission/getRoleInfo",
    data: {
      id,
    },
  });
}
// 删除角色
export function deleteRole(id) {
  return get({
    url: "/common/RolePermission/deleteRole",
    data: {
      id,
    },
  });
}
export function HandlePermissionCache() {
  return get({
    url: "/common/RolePermission/HandlePermissionCache",
  });
}
export function updateBdStatus(data) {
  return get({
    url: "/common/RolePermission/updateBdStatus",
    data: {
      data: JSON.stringify({ ...data }),
    },
  });
}
//更新角色部门
export function postUpdateRoleDepartmentReq(params) {
  return post({
    url: "/common/RolePermission/updateRoleDepartment",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
//获取部门角色权限
export function getDepartmentValueReq() {
  return post({
    url: "/common/RolePermission/getDepartmentValue",
  });
}

// 新建菜单
export function addMenu(params) {
  return post({
    url: "/common/RolePermission/addMenu",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 菜单列表
export function getMenuList(params) {
  return get({
    url: "/common/RolePermission/getMenuList",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 菜单 get
export function getMenuDetail(id) {
  return get({
    url: "/common/RolePermission/getMenu",
    data: {
      id,
    },
  });
}

// 菜单 update
export function updateMenu(params) {
  return get({
    url: "/common/RolePermission/updateMenu",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 后台人员列表
export function getManagersList(params) {
  return get({
    url: "/common/RolePermission/getManagersList",
    data: {
      params: JSON.stringify({ ...params }),
      pageSize: 100,
    },
  });
}
// 新建管理员
export function createManager(params) {
  return post({
    url: "/common/RolePermission/createManager",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 管理员信息
export function getManagerInfo(id) {
  return get({
    url: "/common/RolePermission/getManagerInfo",
    data: {
      id,
    },
  });
}
// edit管理员
export function updateManager(params) {
  return post({
    url: "/common/RolePermission/updateManager",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 删除后台客户
export function deleteManagerUser(id) {
  return post({
    url: "/common/RolePermission/deleteManagerUser",
    data: {
      id,
    },
  });
}
/**
 * 管理员上下级
 */
export function getManagerCacheList() {
  return get({
    url: "/common/RolePermission/getManagerCacheList",
  });
}
export function updateMannagerEffective(data) {
  return post({
    url: "/common/RolePermission/updateManagerEffective",
    data,
  });
}
export function updateMannagerStatus(ID) {
  return get({
    url: "/common/RolePermission/statusSave",
    ID,
  });
}
// 后台人员操作日志
export function getManagerLogList(params) {
  return get({
    url: "/common/RolePermission/getManagerLogList",
    params,
  });
}
/**
 * 操作权限-create
 */
export function createHandlePermission(params) {
  return post({
    url: "/common/RolePermission/createHandlePermission",
    params,
  });
}
/**
 *
 * 操作权限列表
 */
export function HandlePermissionList(params) {
  return get({
    url: "/common/RolePermission/HandlePermissionList",
    params,
  });
}
/**
 * 获取系统开关信息
 */
export function getSystemStatus() {
  return get({
    url: "/common/RolePermission/getSystemStatus",
  });
}
/**
 * 修改传输状态
 */
export function changeSystemTran(data) {
  return get({
    url: "/common/RolePermission/changeSystemTran",
    data,
  });
}

// 列表
export function getDepartment() {
  return get({
    url: "/common/RolePermission/departmentList",
  });
}

export function addDepartment(params) {
  return get({
    url: "/common/RolePermission/addDepartment",
    params,
  });
}

export function getDepartmentInfo(params) {
  return get({
    url: "/common/RolePermission/getDepartment",
    params,
  });
}

export function deletedDepartment(params) {
  return get({
    url: "/common/RolePermission/deletedDepartment",
    params,
  });
}

export function getUserList(params) {
  return get({
    url: "/common/user/list",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 菜单列表
export function checkPermissionRole(role) {
  return get({
    url: "/common/RolePermission/userRole",
    role,
  });
}

export function getDistrict(params) {
  return post({
    url: "/common/districts",
    params,
  });
}

// 客户编辑 - 付款方式 是否显示

export function memberTabPay() {
  return get({
    url: "/common/user/memberTab",
  });
}

// 客户资质时效
export function getUserLicence(user_id) {
  return get({
    url: "/common/user/licence",
    data: {
      user_id,
    },
  });
}
// 资质审核列表
export function getUserQualifyList(params) {
  return get({
    url: "/common/user/getUserQualifyList",
    data: params,
  });
}
// 资质审核详情
export function getUserQualifyAudit(params) {
  return get({
    url: "/common/user/getUserQualifyAudit",
    data: params,
  });
}
// 修改客户资质时效
export function updateLicence(formUserSx) {
  return post({
    url: "/common/user/licence",
    formUserSx: JSON.stringify(formUserSx),
  });
}
// 业务员列表
export function getSalesList() {
  return get({
    url: "/common/user/salesManList",
  });
}

// 客户-业务员信息
export function getUserSalesManRe(user_id) {
  return get({
    url: "/common/user/userSalesMan",
    data: {
      user_id,
      channel: 0,
    },
  });
}
// 更新-客户-业务员员信息
export function updateSaleManRe(user_id, params) {
  return post({
    url: "/common/user/saleManRe",
    data: {
      user_id,
      params,
    },
  });
}

// 客户编辑 -查询客户付款方式
export function payMethods(id) {
  return get({
    url: "/common/user/payWayDetail",
    data: { id },
  });
}
// 客户编辑 -保存客户付款方式
export function savePayMethods(params) {
  return post({
    url: "/common/user/payWaySave",
    data: {
      ...params,
    },
  });
}

// 管理员列表
export function getManageRole(id = null) {
  return get({
    url: "/common/user/managerList",
    id,
  });
}
// 客户-管理员信息
export function getUserManageRe(user_id) {
  return get({
    url: "/common/user/userGly",
    user_id,
  });
}
// 更新-客户-管理员信息
export function updateManageRe(user_id, params) {
  return post({
    url: "/common/user/manageRe",
    data: {
      user_id,
      params,
    },
  });
}
// 客户经营范围
export function getUserJyfw(user_id) {
  return get({
    url: "/common/user/businessScope",
    data: {
      user_id,
    },
  });
}
// 更新经营范围
export function updateJyfw(user_id, params) {
  return post({
    url: "/common/user/updateBusinessScope",
    data: {
      user_id,
      params,
    },
  });
}
// 同步经营范围
export function syncErpUserJyfw(ID) {
  return get({
    url: "/common/user/syncErpBusinessScope",
    data: {
      ID,
    },
  });
}

// 经营范围
export function businessScopeList() {
  return get({
    url: "/common/User/businessScopeList",
  });
}

// 修改基本信息
export function updateUser(fromBase) {
  return post({
    url: "/common/user/updateUser",
    data: {
      fromBase: JSON.stringify({ ...fromBase }),
    },
  });
}
// Show基本信息
export function showUser(user_id) {
  return get({
    url: "/common/user/showUser",
    data: {
      user_id,
    },
  });
}
// 签约客户
export function updateUserMEMBERSHIP(params) {
  return get({
    url: "/common/user/updateUserMEMBERSHIP",
    data: {
      params,
    },
  });
}

// 加盟客户
export function updateUserFRANCHISE(params) {
  return get({
    url: "/common/user/updateUserFRANCHISE",
    data: {
      params,
    },
  });
}

// 审核
export function updateUserREVIEW(params) {
  return get({
    url: "/common/user/updateUserREVIEW",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// VIP
export function updateUserVIP(params) {
  return get({
    url: "/common/user/updateUserVIP",
    data: {
      params,
    },
  });
}

// 指定经营范围
export function updateUserSPECIFIED(params) {
  return get({
    url: "/common/user/updateUserSPECIFIED",
    data: {
      params,
    },
  });
}

// 检验报告
export function updateUserINSPECTION(params) {
  return get({
    url: "/common/user/updateUserINSPECTION",
    data: {
      params,
    },
  });
}

// 状态
export function updateUserSTATUS(params) {
  return get({
    url: "/common/user/updateUserSTATUS",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 开启业务员到付
export function updateUserCASHONDELIVERY(params) {
  return get({
    url: "/common/user/updateUserCASHONDELIVERY",
    data: {
      params,
    },
  });
}
// erp拦截
export function updateErpPayOff(params) {
  return get({
    url: "/common/user/updateErpPayOff",
    data: {
      params,
    },
  });
}

// 货到付款拦截
export function updateHdfkPayOff(params) {
  return get({
    url: "/common/user/updateHdfkPayOff",
    data: {
      params,
    },
  });
}
// 重置密码
export function resetPassword(params) {
  return post({
    url: "/common/user/resetPassword",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 同步erp信息
export function syncErpUserAddress(params) {
  return get({
    url: "/common/user/syncErpUser",
    data: {
      params,
    },
  });
}
// get 首营 info
export function syncFirstUserInfo(params) {
  return get({
    url: "/common/PayInfo/synchronization_user",
    data: {
      ...params,
    },
  });
}
// 线下账期拦截
export function updateErpPayOff_xx(params) {
  return get({
    url: "/common/user/updateErpPayOff_xx",
    method: "get",
    data: {
      ...params,
    },
  });
}
// 是否新客户
export function updateNewCustomer(params) {
  return get({
    url: "/common/user/updateNewCustomer",
    data: {
      ...params,
    },
  });
}
// 手动获取客户经纬度
export function getStreetReq(data) {
  return get({
    url: "/common/user/getStreet",
    data: {
      ...data,
    },
  });
}

// 客户收货信息
export function getUserAddress(user_id) {
  return get({
    url: "/common/user/address",
    data: {
      user_id,
    },
  });
}

// 更新客户收货信息
export function updateAddress(params) {
  return get({
    url: "/common/user/updateAddress",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// 同步erp地址
export function sys_address(ID) {
  return get({
    url: "/common/user/erpAddress",
    data: {
      ID,
    },
  });
}

// 重置客户名
export function updateResetUserName(params) {
  return get({
    url: "/common/user/resetName",
    data: {
      params: JSON.stringify(params),
    },
  });
}
// 客户基本信息
export function getUser(user_id) {
  return get({
    url: "/common/user/userInfo",
    data: {
      user_id,
    },
  });
}

// 客户子账号列表
export function getUserChildReq(params) {
  return get({
    url: "/common/user/userChild",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 获取客户账户使用日志
export function getUserAccountLogList(params) {
  return get({
    url: "/common/userAccount/detail",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}

// 账户余额、积分变动
export function createChangeMoney(params) {
  return post({
    url: "/common/userAccount/changeMoney",
    data: {
      params,
    },
  });
}
// 账户充值余额变动
export function createChargeMoney(params) {
  return post({
    url: "/common/userAccount/createChargeMoney",
    data: {
      params,
    },
  });
}

/**
 * 调节欠款
 */
export function updateQkMoney(params) {
  return post({
    url: "/common/userAccount/updateQkMoney",
    data: {
      params,
    },
  });
}

/**
 * 调节红包金币
 */
export function updateJbHongBao(params) {
  return post({
    url: "/common/userAccount/updateJbHongBao",
    data: {
      params,
    },
  });
}
/**
 * 爆品金
 * @param {*} params
 */
export function updateBaoPinJin(params) {
  return post({
    url: "/common/userAccount/updateBaoPinJin",
    data: {
      params,
    },
  });
}
/**
 * 签到记录
 * @param {客户ID} params
 */
export function getSignLogList(params) {
  return get({
    url: "/common/userAccount/getSignLogList",
    data: {
      params,
    },
  });
}

// 客户
export function getmemberListServe(params) {
  return get({
    url: "/controlSale/role/show",
    data: JSON.stringify({ ...params }),
  });
}

// add客户
export function addmemberServe(params) {
  return post({
    url: "/controlSale/role/addUser",
    data: JSON.stringify({ ...params }),
  });
}
// del客户
export function delmemberServe(params) {
  return post({
    url: "/controlSale/role/delUser",
    data: params,
  });
}
//标签内客户列表
export function getRoleUserListReq(params) {
  return get({
    url: "/controlSale/role/UserList",
    data: JSON.stringify({ ...params }),
  });
}

// get tms info
export function syncTmsInfo(id) {
  return get({
    url: "/common/user/syncTmsInfo",
    data: {
      id,
    },
  });
}
// 订单详情->客户账户信息
export function getUserAccountInfo(id) {
  return get({
    url: "/common/userAccount/info",
    data: {
      id,
    },
  });
}
// 获取人工转账信息
export function get_transfer_accounts(params) {
  return get({
    url: "/common/user/get_transfer_accounts",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 人工转账明细
export function getTransferAccountsList(params) {
  return get({
    url: "/common/user/getTransferAccountsList",
    data: {
      params: JSON.stringify({ ...params }),
    },
  });
}
// 搜索获取客户信息
export function getMemberInfo(params) {
  return get({
    url: "/common/user/getMemberInfo",
    data: {
      params,
    },
  });
}
// 省市区
export function getAllDistricts() {
  return get({
    url: "/common/districtsTree",
  });
}
// 店铺设置列表
export function getFreightTemplateList(params) {
  return get({
    url: "/common/freightTemplate/list",
    data: params,
  });
}
export function insertFreightTemplate(params) {
  return post({
    url: "/common/freightTemplate/create",
    data: params,
  });
}
export function delFreightTemplate(params) {
  return post({
    url: "/common/freightTemplate/delete",
    data: params,
  });
}
export function editFreightTemplate(params) {
  return post({
    url: "/common/freightTemplate/edit",
    data: params,
  });
}
// 企业信息查询
export function getMerchantInfoData(params) {
  return get({
    url: "/common/adminUser/infoMerchant",
    data: params,
  });
}
// 店铺公告
export function editAnnouncement(params) {
  return post({
    url: "/common/adminUser/editAnnouncement",
    data: params,
  });
}
// 店铺头像
export function editMerchantAvatar(params) {
  return post({
    url: "/common/adminUser/editAvatar",
    data: params,
  });
}
// 店铺退货地址
export function editMerchantRefundInfo(params) {
  return post({
    url: "/common/adminUser/editRefundInfo",
    data: params,
  });
}

// 标签列表查询
export function getSalesmanTagList(params) {
  return get({
    url: "/common/salesman/salesmanTag/list",
    data: params,
  });
}
//  业务员列表查询
export function getSalesmanList(params) {
  return get({
    url: "/common/salesman/salesman/list",
    data: params,
  });
}
// 新增业务员
export function insertSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/create",
    data: params,
  });
}
// 修改业务员
export function editSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/edit",
    data: params,
  });
}
// 删除业务员
export function delSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/delete",
    data: params,
  });
}
// 修改业务员状态
export function editStatusSalesmanPerson(params) {
  return post({
    url: "/common/salesman/salesman/editStatus",
    data: params,
  });
}
// 商品-客户列表
export function getSalesmanUserList(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/listUser",
    data: params,
  });
}
export function insertSalesmanUser(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/createUser",
    data: params,
  });
}
export function deleteSalesmanUser(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/deleteUser",
    data: params,
  });
}
// 根据商品获取区域
export function getPreviousArea(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/parentDistrict",
    data: params,
  });
}

// 标签列表查询
export function getSalesmanTagTypeList(params) {
  return get({
    url: "/common/salesman/tagType/list",
    data: params,
  });
}
// 新增标签
export function insertSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/create",
    data: params,
  });
}
// 编辑标签
export function editSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/edit",
    data: params,
  });
}
// 删除标签
export function delSalesmanTagType(params) {
  return post({
    url: "/common/salesman/tagType/delete",
    data: params,
  });
}
// 修改标签状态
export function editSalesmanTagTypeStatus(params) {
  return post({
    url: "/common/salesman/tagType/editStatus",
    data: params,
  });
}

// 修改标签状态
export function getTagsByType(params) {
  return post({
    url: "/common/salesman/tagType/getTagsByType",
    data: params,
  });
}


// 业务员-商品列表
export function getSalesmanGoodsList(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/list",
    data: params,
  });
}
export function insertSalesmanGoods(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/create",
    data: params,
  });
}
export function editSalesmanGoods(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/edit",
    data: params,
  });
}
export function delGoodsSalesman(params) {
  return post({
    url: "/common/salesman/salesmanGoodsRoyalty/delete",
    data: params,
  });
}

// 客户购物车列表
export function getCartInfoList(params) {
  return get({
    url: "/common/user.User/getCartInfoList",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// 客户购物车明细
export function getCartInfoDetail(params) {
  return get({
    url: "/common/user.User/getCartInfoDetail",
    data: {
      params: JSON.stringify(params),
    },
  });
}

// 财务 - 货款
export function goodsPaymentList(params) {
  return get({
    url: "/common/finance/settlement/goodsPaymentList",
    data: params,
  });
}
// 财务- 提现
export function royaltyMoneyList(params) {
  return get({
    url: "/common/finance/withdraw/merchantWithdrawList",
    data: params,
  });
}
// 财务- 运费
export function freightAmountList(params) {
  return get({
    url: "/common/finance/settlement/freightAmountList",
    data: params,
  });
}
// 商家账户信息
export function getMerchantAccountInfo(params) {
  return get({
    url: "/common/finance/settlement/accountInfo",
    data: params,
  });
}

// 提现申请
export function merchantWithdrawRequest(params) {
  return post({
    url: "/common/finance/withdraw/merchantWithdrawRequest",
    data: params,
  });
}

// 商品关联的业务员
export function getGoodsContactSalesman(params) {
  return get({
    url: "/common/salesman/salesmanGoodsRoyalty/goodsListSalesman",
    data: params,
  });
}


export function goodsUpload(params) {
  return post({
    url: "/controlSale/marketing/activity/import",
    data: params,
  });
}


export function goodsDownloadFileBase64(params) {
  return get({
    url: "/controlSale/marketing/activity/export",
    data: params,
  });
}


export function downloadBlob(fileName, data) {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  // 清理
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }, 100);
}

export function downloadUrl(url) {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  setTimeout(function loadUrl() {
    iframe.contentWindow.location.href = url
  }, 50)
}

// 查询经营类别
export function getBusinessScopeList(params) {
  return get({
    url: "/common/basic/businessScope/list",
    data: params,
  });
}

// 客户类型
export function getQualificationType(params) {
  return get({
    url: "/common/user.qualification/type",
    data: params,
  })
}
// 查询物流配置
export function getExpressDeliveryList(params) {
  return get({
    url: "/common/basic/expressDelivery/list",
    data: params,
  });
}
// 新增物流配置
export function insertExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/create",
    data: params,
  });
}
// 编辑物流配置
export function editExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/edit",
    data: params,
  });
}
// 删除物流配置
export function delExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/delete",
    data: params,
  });
}
// 修改物流状态
export function editStatusExpressDelivery(params) {
  return post({
    url: "/common/basic/expressDelivery/editStatus",
    data: params,
  });
}
//#region 编辑银行转账信息
export function postAdminUserUpdateBankInfoReq(params) {
  return post({
    url: "/common/adminUser/updateBankInfo",
    data: params,
  });
}
//#endregion
//客户类型 列表
export function getBasicUserTypeListReq(params) {
  return get({
    url: "/common/basic/userType/list",
    data: params,
  });
}

// 生成企业密钥
export function makeSecretKey(params) {
  return get({
    url: "/common/adminUser/makeSecretKey",
    data: params,
  });
}

// erp链接状态
export function merchantErpStatus(params) {
  return get({
    url: "/common/adminUser/merchantErpStatus",
    data: params,
  });
}
